import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { morph } from '@theme/morph';

/** @extends {Component<{facts: HTMLElement}>} */
class ProductSpecifications extends Component {
  requiredRefs = ['facts'];
  #controller;
  #request = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#update, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#request++;
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #update = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    try {
      const result = await event.promise;
      if (request !== this.#request || this.#controller.signal.aborted) return;
      const detail = result?.detail;
      if (!detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const source = detail.html.querySelector(
        `product-specifications[data-block-id="${CSS.escape(this.dataset.blockId)}"] [ref="facts"]`
      );
      if (!source) return;
      morph(this.refs.facts, source, { childrenOnly: true });
      if (detail.newProduct) this.dataset.productId = detail.newProduct.id;
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[product-specifications] Update failed:', error);
    }
  };
}

if (!customElements.get('product-specifications')) {
  customElements.define('product-specifications', ProductSpecifications);
}
